import React from 'react';
import { ChevronRightIcon } from '@chakra-ui/icons';
import { Center, Text, useToast } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { Device } from 'clipsal-cortex-types/src/api';

export function DetailsConfigurationButton({ device }: { device: Device }) {
  const { device_type: deviceType } = device;
  const { t } = useTranslation();
  const navigate = useNavigate();
  const toast = useToast();

  const handleOnClick = () => {
    switch (deviceType) {
      case 'EV_CHARGER':
        navigate(`../../../../home/device-power-up-instructions`);
        break;
      default:
        toast({
          title: t('Hardware.wifi config unavailable'),
          description: t('Hardware.this feature is currently'),
          status: 'info',
          isClosable: true,
          duration: 5000,
        });
        break;
    }
  };

  return (
    <Center
      justifyContent={'space-between'}
      role={'button'}
      mt={6}
      py={6}
      px={4}
      mx={-5}
      bg={'#E7E6E6'}
      _dark={{
        bg: '#363E40',
      }}
      data-testid="wifi-config-button"
      onClick={handleOnClick}
    >
      <Text>{t('Hardware.config')}</Text>
      <ChevronRightIcon color={'customGrey.400'} h={6} w={6} />
    </Center>
  );
}
